export enum FeatureToggle {
  featureEntitlementsManagement = 'rt_feature_entitlements_management_nav_view',
}
